import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import './App.css';
import OrderPage from './OrderPage';
import NetworkStatus from './components/NetworkStatus';
import DiagnosticPage from './DiagnosticPage';
import LandingPage from './LandingPage';

function App() {
  return (
    <Router>
      <NetworkStatus />
      <Routes>
        <Route path="/order/:orderId" element={<OrderPage />} />
        <Route path="/diagnostic" element={<DiagnosticPage />} />
        <Route path="/" element={<LandingPage />} />
      </Routes>
    </Router>
  );
}

export default App;
